export const calendarTypes = {
  prewire: 'prewire',
  cddd: 'cddd',
  doi: 'doi',
  gen: 'gen',
  install: 'install',
  escalation: 'escalation',
  both: 'both'
}

export const quotaRequestCalendarTypes = {
  prewire: 'Prewire',
  doi: 'DOI'
}


export const timeSlots = [
  {
    id: 'AM',
    time: 'AM'
  },
  {
    id: 'PM',
    time: 'PM'
  },
  {
    id: 'ANY',
    time: 'ANY'
  }
]

export const NO_CALENDAR_DATES = 'NO_CALENDAR_DATES'

/* ABT */
export const ABT_REQUIRED = 'ABT_REQUIRED'
export const ABT_ADDRESS_CREATE_SUCCESS = 'ABT_ADDRESS_CREATE_SUCCESS'
export const ABT_ADDRESS_CREATE_FAILURE = 'ABT_ADDRESS_CREATE_FAILURE'

/* GENESIS */
export const GENESIS_IHAT = 'GENESIS_IHAT'

export const CALENDAR_TABS = {
  FULL_AUTOMATION: 'FullAutomation',
  PARTIAL_AUTOMATION: 'PartialAutomation'
}

export const TAB_LABELS = {
  [CALENDAR_TABS.FULL_AUTOMATION]: 'Continue with Full Automation',
  [CALENDAR_TABS.PARTIAL_AUTOMATION]: 'Switch to Partial Automation'
}

export const CALENDAR_CSS_CLASSES = {
  HIGHLIGHTED_DAY: 'react-datepicker__day--highlighted'
}

export const DATE_FORMATS = {
  ISO_DATE: 'YYYY-MM-DD'
}

export const TIME_SLOT_IDS = {
  AM: 'AM',
  PM: 'PM',
  ANY: 'ANY'
}

export const INSTALL_TIME_SLOT_KEYS = {
  CDDD: 'selectedCdddTime',
  DOI: 'selectedDateOfInstallTime'
}

export const API_SEARCH_TERMS = {
  SUBMIT: 'submit',
  VALIDATE: 'validate'
}

export const MESSAGE_KEYWORDS = {
  TECHNICAL_ISSUE: 'technical issue',
  TIMESLOTS: 'timeslots'
}

export const MERGEABLE_CALENDAR_PROPERTIES = [
  'installMessageCodes',
  'genesisIhatMessage',
  'newTimeslotSelectionMessage',
  'apiAction',
  'apiUrl',
  'preWireMinGapBeforeInstallCalendar',
  'isFullAutomationOrder'
]

export const CALENDAR_INSTRUCTION_MESSAGES = {
  PREWIRE: {
    SELECT: 'Select your preferred Pre-Wire start date from the next 30 available days.',
    QUOTA: 'Click REQUEST QUOTA to see available Pre-Wire timeslots.'
  },
  INSTALL: {
    SELECT: 'Select your preferred start date from the next 30 available days.',
    QUOTA: 'Click REQUEST QUOTA to see available timeslots for your selected date.'
  },
  DOI_WITH_PREWIRE: {
    SELECT: 'Select your preferred installation date to continue.',
    QUOTA: 'Click REQUEST QUOTA to see available installation timeslots.'
  }
}

export const CALENDAR_TOOLTIP_MESSAGES = {
  PREWIRE_QUOTA: 'Please select a prewire date from the calendar to request quota.',
  INSTALL_QUOTA: 'Please select an install date from the calendar to request quota.'
}

export const CALENDAR_WARNING_MESSAGES = {
  INSTALL_DATE_REQUIRED: 'Please select Pre-Wire date and timeslot to enable Install scheduling.'
}